module.exports = __webpack_public_path__ + "img/08.95c8d8db.jpg";